<template>
  <BaseIndicator
    data-test="indicator"
    icon="check"
    variant="success"
    :size="size"
  />
</template>

<script>
import BaseIndicator from '@/components/library/indicators/BaseIndicator.vue';

export default {
  name: 'SuccessIndicator',
  components: {
    BaseIndicator,
  },
  props: {
    size: {
      type: String,
      required: false,
    },
  },
};
</script>
